import { useTranslation } from 'react-i18next';
import { I18N_FALLBACK_LOCALE } from '@withjoy/locale';
import { resolveSupportedLocale } from '@shared/core/i18n/utils';
import { localeUrl } from '@shared/utils/localeUrl';

/** The current locale, resolved to one joy-web supports. */
export const useCurrentLocale = (): string => {
  const { i18n } = useTranslation();
  return resolveSupportedLocale(i18n.language || I18N_FALLBACK_LOCALE).locale;
};

/**
 * `url` in the current locale. Use it for anything that must match a localized page's canonical,
 * such as JSON-LD `url` and `@id`.
 */
export const useLocalizedUrl = (url: string): string => localeUrl(url, useCurrentLocale());
